export const frontmatter = {
    "draft": true,
    "title": "Primeros pasos por rol",
    "description": "Guía de primeros pasos en OnnIA según tu rol: Owner del Team, Admin, Creator, Tester y roles del Tenant Enterprise.",
    "sidebar_label": "Primeros pasos por rol",
    "sidebar_group": "quickstart",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "tipos-de-espacios-en-onnia",
        "value": "Tipos de espacios en OnnIA"
    },
    {
        "depth": 2,
        "id": "roles-en-el-tenant-default",
        "value": "Roles en el Tenant Default"
    },
    {
        "depth": 3,
        "id": "owner-del-team",
        "value": "Owner del Team"
    },
    {
        "depth": 3,
        "id": "owner-del-proyecto",
        "value": "Owner del Proyecto"
    },
    {
        "depth": 3,
        "id": "admin-del-team",
        "value": "Admin del Team"
    },
    {
        "depth": 3,
        "id": "creator-developer",
        "value": "Creator (Developer)"
    },
    {
        "depth": 3,
        "id": "tester",
        "value": "Tester"
    },
    {
        "depth": 2,
        "id": "roles-en-el-tenant-enterprise",
        "value": "Roles en el Tenant Enterprise"
    },
    {
        "depth": 3,
        "id": "usuario-del-tenant-enterprise",
        "value": "Usuario del Tenant Enterprise"
    },
    {
        "depth": 3,
        "id": "propietario-del-tenant-enterprise",
        "value": "Propietario del Tenant Enterprise"
    },
    {
        "depth": 3,
        "id": "super-admin-del-sistema",
        "value": "Super Admin del Sistema"
    }
]